<template>
  <div class="product-index" id="productindex">
    <van-popup
      v-model="contact_modal"
      closeable
      round
      :style="{ width: '90%' }"
    >
      <van-image
        fit="contain"
        style="width: 90vw; min-height: 90vw"
        lazy-load
        src="https://wobei01-release-1251634031.cos.ap-guangzhou.myqcloud.com/zhangzhan.png"
      />
    </van-popup>
    <div class="right-btn">
      <div class="btn-server" @click="contact_modal = true">客服</div>
    </div>
    <div class="product-head"></div>
    <div class="product-content">
      <div class="firminfo">
        <img
          src="../../../static/images/icon/icon-qyhead.png"
          alt=""
          v-if="firminfo == null"
          class="firmicon"
        />
        <van-image
          lazy-load
          class="firmicon"
          v-else
          :src="firminfo.corp_square_logo_url"
          fit="contain"
        />

        <div class="firmdesc" v-if="firminfo == null">
          <van-loading />
        </div>
        <div class="firmdesc" v-else>
          <div class="xl-title">{{ firminfo.corp_name }}</div>
          <div class="vipinfo">
            {{ firmVersionDetail.version
            }}<template v-if="firmVersionDetail.expdate"
              >{{ firmVersionDetail.expdate_format }}过期</template
            >
          </div>
        </div>
      </div>
      <div class="vipmenu">
        <div class="vipmenu-item active">
          引流活码系统
          <div class="line">&nbsp;</div>
        </div>
        <!-- <div class="vipmenu-item " @click="goAnchor('vipmenuliebian')">
          裂变锁客系统
          <div class="line">&nbsp;</div>
        </div> -->
      </div>
      <div class="version">
        <div
          :class="
            'version-item' + (productno_sel == ptypes.基础版 ? ' active' : '')
          "
          @click="productno_sel = ptypes.基础版"
        >
          <div class="xl-title">体验版</div>
        </div>
        <div
          :class="
            'version-item' + (productno_sel == ptypes.高级版 ? ' active' : '')
          "
          @click="productno_sel = ptypes.高级版"
        >
          <div class="xl-title">高级版</div>
          <div class="xm-title"><span class="hig">￥1999</span>/年</div>
          <div class="xm-title">折合<span class="hig">￥5.47</span>/天</div>
        </div>
        <div
          :class="
            'version-item' + (productno_sel == ptypes.专业版 ? ' active' : '')
          "
          @click="productno_sel = ptypes.专业版"
        >
          <div class="xl-title">专业版</div>
          <div class="xm-title"><span class="hig">￥3999</span>/年</div>
          <div class="xm-title">折合<span class="hig">￥10.95</span>/天</div>
        </div>
      </div>
      <div class="xieyi">
        <van-checkbox
          v-model="agreeBuyProtocol"
          checked-color="#4356d2"
          shape="square"
        ></van-checkbox
        >已阅读并同意<a
          class="hig"
          target="_blank"
          href="https://www.huobanmao.com/news/4086.html"
          >《服务协议》</a
        >
      </div>
      <template v-if="productno_sel == ptypes.高级版 && firminfo != null">
        <button
          class="btn-xl-buy btn-enabled"
          v-if="firmVersionDetail.version == '专业版'"
        >
          您的企业已购买更高级版本
        </button>
        <button
          class="btn-xl-buy"
          @click="gopay(productno_sel)"
          v-else-if="firmVersionDetail.version == '高级版'"
        >
          立即续费
        </button>
        <button class="btn-xl-buy" @click="gopay(productno_sel)" v-else>
          立即购买
        </button>
      </template>
      <template v-else-if="productno_sel == ptypes.专业版 && firminfo != null">
        <button
          class="btn-xl-buy"
          @click="gopay(productno_sel)"
          v-if="firmVersionDetail.version == '专业版'"
        >
          立即续费
        </button>
        <button class="btn-xl-buy" @click="gopay(productno_sel)" v-else>
          立即购买
        </button>
      </template>
      <button class="btn-xl-buy btn-enabled" v-else>立即购买</button>
      <div class="version-title">
        <span class="line"></span>
        <span class="round"></span>
        <span class="text">服务包含</span>
        <span class="round"></span>
        <span class="line"></span>
      </div>
      <div class="version-desc">
        <div
          v-for="(v, i) in ptypedescs"
          :key="i"
          v-show="v.productno == productno_sel"
        >
          <van-collapse v-model="activeNames">
            <van-collapse-item
              class="product-clitem"
              style="border:none;margin:0px;padding:0px;"
              :name="j + 1"
              v-for="(va, k, j) in v.descs"
              :key="j"
            >
              <template #title>
                <span style="color:#121212;font-weight: 400;font-size: vw(30);">
                  {{ k }}
                </span>
                <!-- 没有三合一 -->
                <span v-if="!getPackageInfo(ptypes.超级拓展包)">
                  <span v-if="k == '获客表单'">
                    <span class="text" v-if="getPackageInfo(ptypes.表单拓展包)"
                      >(
                      {{ getPackageInfo(ptypes.表单拓展包).expdate_format }}到期
                      )</span
                    >
                  </span>

                  <span v-else-if="k == '好友裂变'">
                    <span class="text" v-if="getPackageInfo(ptypes.好友裂变)"
                      >(
                      {{ getPackageInfo(ptypes.好友裂变).expdate_format }}到期
                      )</span
                    >
                  </span>

                  <span v-else-if="k == '冲榜裂变'">
                    <span class="text" v-if="getPackageInfo(ptypes.冲榜裂变)"
                      >(
                      {{ getPackageInfo(ptypes.冲榜裂变).expdate_format }}到期
                      )</span
                    >
                  </span>
                </span>

                <!-- 有三合一 -->
                <span v-else>
                  <span v-if="k == '获客表单'">
                    <span class="text"
                      >( 三合一
                      {{ getPackageInfo(ptypes.超级拓展包).expdate_format }}到期
                      )</span
                    >
                  </span>

                  <span v-else-if="k == '好友裂变'">
                    <span class="text"
                      >( 三合一
                      {{ getPackageInfo(ptypes.超级拓展包).expdate_format }}到期
                      )</span
                    >
                  </span>

                  <span v-else-if="k == '冲榜裂变'">
                    <span class="text"
                      >( 三合一
                      {{ getPackageInfo(ptypes.超级拓展包).expdate_format }}到期
                      )</span
                    >
                  </span>
                </span>
              </template>
              <div v-for="(item, index) in va" class="showCard" :key="index">
                <span class="title"> {{ item.title }} </span>
                <span class="desc" v-if="item.desc">{{ item.desc }}</span>
                <template v-else>
                  <img
                    v-if="item.ishave"
                    src="../../../static/images/product/icon-success@2x.png"
                    alt=""
                    class="icon"
                  />
                  <img
                    v-else
                    src="../../../static/images/product/icon-nohave.png"
                    alt=""
                    class="icon"
                  />
                </template>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
        <!-- <ul
          v-for="(v, i) in ptypedescs"
          :key="i"
          v-show="v.productno == productno_sel"
        >
        <li v-for="(va, k , j) in v.descs" :key="j" >
        <van-collapse accordion  v-model="activeNames" v-if="v.productno == productno_sel">
           <van-collapse-item style="border:none;margin:0px" title="标题1" :name="j+'1'">内容1</van-collapse-item>
           <van-collapse-item style="border:none;margin:0px" title="标题2" :name="j+'1'">内容2</van-collapse-item>
           <van-collapse-item style="border:none;margin:0px" title="标题3" :name="j+'1'">内容3</van-collapse-item>
        </van-collapse>
        </li> -->
        <!-- <van-collapse v-model="activeNames" accordion >
           <van-collapse-item style="border:none;margin:0px" title="标题1" name="1">内容1</van-collapse-item>
           <van-collapse-item style="border:none;margin:0px" title="标题2" name="2">内容2</van-collapse-item>
           <van-collapse-item style="border:none;margin:0px" title="标题3" name="3">内容3</van-collapse-item>
        </van-collapse> -->
        <!-- <li v-for="(vi, j) in v.descs" :key="j">
            <span class="title">{{ vi.title }}</span>
            <span class="desc" v-if="vi.desc">{{ vi.desc }}</span>
            <template v-else>
              <img
                v-if="vi.ishave"
                src="../../../static/images/product/icon-success@2x.png"
                alt=""
                class="icon"
              />
              <img
                v-else
                src="../../../static/images/product/icon-nohave.png"
                alt=""
                class="icon"
              />
            </template>
          </li>
        </ul> -->
      </div>
    </div>

    <!-- <div class="product-content product-content-bg" id="vipmenuliebian">
      <div class="vipmenu">
        <div class="vipmenu-item active">
          裂变锁客系统
          <div class="line">&nbsp;</div>
        </div>
      </div>
      <div class="package-list">
        <div class="package-item" id="biaodan">
          <div class="package-head">
            <span class="package-title">获客表单（拓展包）</span>
            <span
              class="package-exptime"
              v-if="getPackageInfo(ptypes.表单拓展包)"
              >{{ getPackageInfo(ptypes.表单拓展包).expdate_format }}到期</span
            >
          </div>
          <div class="package-desc">
            <ul>
              <li>1.不同选项提交后展示不同内容</li>
              <li>2.不同选项提交后跳转不同链接</li>
              <li>3.自动给填写表单的企业微信好友打标签</li>
              <li>4.生成专属分享二维码海报</li>
              <li>5.记录用户分享推荐关系</li>
            </ul>
          </div>
          <div class="package-bottom">
            <span class="package-price">￥199/年</span>
            <button class="btn-sm-buy" @click="gopay(ptypes.表单拓展包)">
              {{ getPackageInfo(ptypes.表单拓展包) ? "去续费" : "去购买" }}
            </button>
          </div>
        </div>

        <div class="package-item">
          <div class="package-head">
            <span class="package-title">冲榜裂变</span>
            <span class="package-exptime" v-if="getPackageInfo(ptypes.冲榜裂变)"
              >{{ getPackageInfo(ptypes.冲榜裂变).expdate_format }}到期</span
            >
          </div>
          <div class="package-desc">
            <ul>
              <li>1.用户添加好友自动生成专属裂变名片海报</li>
              <li>2.支持设置虚拟、实物、外部链接、到店核销等多类型奖励诱饵</li>
              <li>3.支持按完成任务或者邀请排行自动兑奖</li>
              <li>4.支持用户添加好友自动兑奖</li>
              <li>5.海报灵活个性化配置</li>
              <li>6.满400人自动分流</li>
              <li>7.裂变参考话术</li>
              <li>8.实时排行榜</li>
              <li>9.客户任务完成兑奖提醒</li>
              <li>10.记录用户分享推荐关系</li>
              <li>11.活动结束回复设置</li>
              <li>12.裂变数据统计分析</li>
            </ul>
          </div>
          <div class="package-bottom">
            <span class="package-price">￥1599/年</span
            ><button class="btn-sm-buy" @click="gopay(ptypes.冲榜裂变)">
              {{ getPackageInfo(ptypes.冲榜裂变) ? "去续费" : "去购买" }}
            </button>
          </div>
        </div>

        <div class="package-item">
          <div class="package-head">
            <span class="package-title">好友裂变</span>
            <span class="package-exptime" v-if="getPackageInfo(ptypes.好友裂变)"
              >{{ getPackageInfo(ptypes.好友裂变).expdate_format }}到期</span
            >
          </div>
          <div class="package-desc">
            <ul>
              <li>1.用户关注公众号自动生成专属裂变名片海报</li>
              <li>2.支持用户添加好友自动兑奖</li>
              <li>3.支持按完成任务或者邀请排行自动兑奖</li>
              <li>4.海报灵活个性化配置</li>
              <li>5.满400人自动分流</li>
              <li>6.裂变参考话术</li>
              <li>7.实时排行榜</li>
              <li>8.客户任务完成兑奖提醒</li>
              <li>9.记录用户分享推荐关系</li>
              <li>10.活动结束回复设置</li>
              <li>11.裂变数据统计分析</li>
            </ul>
          </div>
          <div class="package-bottom">
            <span class="package-price">￥1599/年</span
            ><button class="btn-sm-buy" @click="gopay(ptypes.好友裂变)">
              {{ getPackageInfo(ptypes.好友裂变) ? "去续费" : "去购买" }}
            </button>
          </div>
        </div>

        <div class="package-item">
          <div class="package-head">
            <span class="package-title">至尊三合一</span>
            <span
              class="package-exptime"
              v-if="getPackageInfo(ptypes.超级拓展包)"
              >{{ getPackageInfo(ptypes.超级拓展包).expdate_format }}到期</span
            >
          </div>
          <div class="package-desc">
            <ul>
              <li>拥有以上三个包的全部功能</li>
            </ul>
          </div>
          <div class="package-bottom">
            <span class="package-price">￥1999/年</span
            ><button class="btn-sm-buy" @click="gopay(ptypes.超级拓展包)">
              {{ getPackageInfo(ptypes.超级拓展包) ? "去续费" : "去购买" }}
            </button>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <br /><br />商品页面啦啦啦<br /><br />
    <van-button
      type="default"
      :loading="h5loading"
      loading-text="H5支付"
      @click="buildorderh5"
      >H5支付</van-button
    ><br /><br />
    <van-button
      type="primary"
      :loading="nativeloading"
      loading-text="扫码支付"
      @click="buildordernat"
      >扫码支付</van-button
    ><br /><br />
    <van-button
      type="danger"
      :loading="jssdkloading"
      loading-text="jssdk支付"
      @click="buildorderjs"
      >jssdk支付</van-button
    > -->
    <van-popup v-model="nativeshow" closeable @close="nativeclose">
      <div class="native-box">
        <!-- <div class="native-success">
         &nbsp;
        </div>
        <img class="native-success-icon"
            src="../../../static/images/icon/icon-checked.png"
            alt=""
          /> -->
        <div class="icon-wxpay">
          <img src="../../../static/images/icon-wechat.png" alt="" />
        </div>
        <div class="title">￥{{ natorderamount }}</div>
        <img :src="natlinkqrcode" alt="" class="qrcode" />
        <div class="desc" v-if="natstatus == 0">
          <van-icon name="scan" />请打开微信进行扫码支付
        </div>
        <div class="success" v-else>
          <van-icon name="success" />支付成功，正在跳转...
        </div>
      </div>
    </van-popup>

    <van-popup v-model="payresultshow" closeable>
      <div class="message-box">
        <div class="info">请确认微信支付是否已经成功</div>

        <van-button
          type="primary"
          block
          :loading="queryordering"
          loading-text="我已完成支付"
          @click="QueryOrder(1)"
          >我已完成支付</van-button
        >
        <van-button type="default" block @click="reh5pay"
          >支付遇到问题，重新支付</van-button
        >
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Steps, Toast, step, Checkbox } from "vant";
import { Dialog } from "vant";
import { Loading } from "vant";
Vue.use(Loading);
Vue.use(Checkbox);
Vue.use(Steps);
Vue.use(step);
Vue.use(Toast);
Vue.use(Toast);

var timer = null;
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import { newname } from "@/util/crypto";
import Vue from "vue";
import config from "@/config";
import ptypes from "@/producttype";
export default {
  name: "product-index",
  data() {
    return {
      activeNames: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      contact_modal: false,
      agreeBuyProtocol: true,
      firstloading: false,
      //显示扫码支付窗口
      nativeshow: false,

      h5loading: false,
      nativeloading: false,
      jssdkloading: false,
      jssdkparams: null,
      natlink: "",
      natlinkqrcode: "",
      natorderamount: 0,
      natstatus: 0,
      iorder: { productno: ptypes.高级版, paycount: 1, payunit: 1 },
      productno_sel: ptypes.高级版,
      orderno: "",
      payorderno: "",

      payresultshow: false,
      queryordering: false,

      ptypes: ptypes,
      ptypedescs: [
        {
          productno: ptypes.基础版,
          descs: {
            绑定数量: [
              { title: "支持绑定的企业微信数量", desc: "1个", ishave: true },
            ],
            活码限制: [
              { title: "创建二维码数量", desc: "10个", ishave: true },
              {
                title: "总引流人数限制",
                desc: "累计150人/月超出后增加文字广告",
                ishave: true,
              },
            ],
            活码类型: [
              { title: "永久群活码", desc: "", ishave: false },
              { title: "渠道名片码", desc: "", ishave: true },
              { title: "自动拉群", desc: "", ishave: false },
              { title: "多人活码", desc: "", ishave: true },
            ],
            欢迎语回复: [
              { title: "加好友自动发消息", desc: "", ishave: true },
              { title: "自动发送专属欢迎语/图片/外链", desc: "", ishave: true },
              { title: "自动生成专属欢迎海报", desc: "", ishave: false },
              { title: "插入用户昵称，员工姓名等个性化标签", desc: "", ishave: false },
              { title: "自动打标签", desc: "", ishave: true },
            ],
            获客表单: [
              { title: "设计、发布表单", desc: "", ishave: true },
              { title: "表单模板中心", desc: "", ishave: true },
              { title: "表单数据查看与导出", desc: "", ishave: true },
              { title: "重复填写限制", desc: "", ishave: true },
              { title: "跳题逻辑/关联逻辑", desc: "", ishave: true },
              { title: "用户报名数据微信提醒查看", desc: "", ishave: true },
              {
                title: "不同选项提交之后展示不同内容",
                desc: "",
                ishave: false,
              },
              {
                title: "不同选线提交之后跳转不同链接",
                desc: "",
                ishave: false,
              },
              {
                title: "自动给填写表单的企业微信好友打标签",
                desc: "",
                ishave: false,
              },
              { title: "生成专属分享二维码", desc: "", ishave: false },
              { title: "记录用户分享的推荐关系", desc: "", ishave: false },
            ],
            好友裂变: [
              {
                title: "用户添加好友自动生成专属裂变名片海报",
                desc: "",
                ishave: false,
              },
              { title: "支持设置多类型奖励", desc: "", ishave: false },
              {
                title: "支持按完成任务或者邀请排行自动兑奖",
                desc: "",
                ishave: false,
              },
              { title: "支持用户添加好友自动兑奖", desc: "", ishave: false },
              { title: "支持用户添加自动打标签", desc: "", ishave: false },
              { title: "海报灵活个性化配置", desc: "", ishave: false },
              { title: "可实现多人自动分流", desc: "", ishave: false },
              { title: "提供裂变参考话术", desc: "", ishave: false },
              { title: "提供实时排行榜", desc: "", ishave: false },
              { title: "客户任务完成兑奖提醒", desc: "", ishave: false },
              { title: "记录用户分享推荐关系", desc: "", ishave: false },
              { title: "活动结束回复设置", desc: "", ishave: false },
            ],
            冲榜裂变: [
              {
                title: "用户关注公众号自动生成专属裂变名片海报",
                desc: "",
                ishave: false,
              },
              { title: "支持设置多类型奖励", desc: "", ishave: false },
              {
                title: "支持按完成任务或者邀请排行自动兑奖",
                desc: "",
                ishave: false,
              },
              { title: "支持用户添加好友自动兑奖", desc: "", ishave: false },
              { title: "支持用户添加自动打标签", desc: "", ishave: false },
              { title: "支持用户添加好友自动拉群", desc: "", ishave: false },
              { title: "海报灵活个性化配置", desc: "", ishave: false },
              { title: "可实现多人自动分流", desc: "", ishave: false },
              { title: "提供裂变参考话术", desc: "", ishave: false },
              { title: "提供实时排行榜", desc: "", ishave: false },
              { title: "记录用户分享推荐关系", desc: "", ishave: false },
              { title: "活动结束回复设置", desc: "", ishave: false },
            ],
            推广素材库: [
              { title: "海报模板套用", desc: "限时免费", ishave: false },
              { title: "发圈模板套用", desc: "限时免费", ishave: false },
              { title: "团队素材共创共享", desc: "限时免费", ishave: false },
            ],
            数据统计分析: [
              { title: "总拉新人数统计", desc: "", ishave: false },
              { title: "每日拉新人数统计", desc: "", ishave: false },
              { title: "引流数据统计", desc: "", ishave: true },
              { title: "裂变传播数据分析", desc: "", ishave: false },
            ],
            母版设置同步: [
              { title: "引流活码设置同步", desc: "", ishave: false },
              { title: "裂变活动设置同步", desc: "", ishave: false },
              { title: "获客表单设置同步", desc: "", ishave: false },
            ],
            增值服务: [
              { title: "软件安装配置", desc: "", ishave: true },
              { title: "专属客服", desc: "", ishave: false },
              { title: "官方教程", desc: "", ishave: true },
              { title: "3天企业微信获客训练营", desc: "", ishave: false },
              { title: "23节企业微信运营增长体系课", desc: "", ishave: false },
              { title: "线下课程培训", desc: "按需收费", ishave: false },
              { title: "运营方案策划", desc: "按需收费", ishave: false },
              { title: "社群运营指导", desc: "", ishave: false },
              { title: "功能定制", desc: "按需收费", ishave: false },
            ],
          },
        },
        {
          productno: ptypes.高级版,
          descs: {
            绑定数量: [
              { title: "支持绑定的企业微信数量", desc: "1个", ishave: true },
            ],
            活码限制: [
              { title: "创建二维码数量", desc: "不限", ishave: true },
              {
                title: "总引流人数限制",
                desc: "累计500人/月超出后增加文字广告",
                ishave: true,
              },
            ],
            活码类型: [
              { title: "永久群活码", desc: "", ishave: true },
              { title: "渠道名片码", desc: "", ishave: true },
              { title: "自动拉群", desc: "", ishave: true },
              { title: "多人活码", desc: "", ishave: true },
            ],
            欢迎语回复: [
              { title: "加好友自动发消息", desc: "", ishave: true },
              { title: "自动发送专属欢迎语/图片/外链", desc: "", ishave: true },
              { title: "自动生成专属欢迎海报", desc: "", ishave: true },
              { title: "插入用户昵称，员工姓名等个性化标签", desc: "", ishave: true },
              { title: "自动打标签", desc: "", ishave: true },
            ],
            获客表单: [
              { title: "设计、发布表单", desc: "", ishave: true },
              { title: "表单模板中心", desc: "", ishave: true },
              { title: "表单数据查看与导出", desc: "", ishave: true },
              { title: "重复填写限制", desc: "", ishave: true },
              { title: "跳题逻辑/关联逻辑", desc: "", ishave: true },
              { title: "用户报名数据微信提醒查看", desc: "", ishave: true },
              { title: "不同选项提交之后展示不同内容", desc: "", ishave: true },
              { title: "不同选线提交之后跳转不同链接", desc: "", ishave: true },
              {
                title: "自动给填写表单的企业微信好友打标签",
                desc: "",
                ishave: true,
              },
              { title: "生成专属分享二维码", desc: "", ishave: true },
              { title: "记录用户分享的推荐关系", desc: "", ishave: true },
            ],
            好友裂变: [
              {
                title: "用户添加好友自动生成专属裂变名片海报",
                desc: "",
                ishave: false,
              },
              { title: "支持设置多类型奖励", desc: "", ishave: false },
              {
                title: "支持按完成任务或者邀请排行自动兑奖",
                desc: "",
                ishave: false,
              },
              { title: "支持用户添加好友自动兑奖", desc: "", ishave: false },
              { title: "支持用户添加自动打标签", desc: "", ishave: false },
              { title: "海报灵活个性化配置", desc: "", ishave: false },
              { title: "可实现多人自动分流", desc: "", ishave: false },
              { title: "提供裂变参考话术", desc: "", ishave: false },
              { title: "提供实时排行榜", desc: "", ishave: false },
              { title: "客户任务完成兑奖提醒", desc: "", ishave: false },
              { title: "记录用户分享推荐关系", desc: "", ishave: false },
              { title: "活动结束回复设置", desc: "", ishave: false },
            ],
            冲榜裂变: [
              {
                title: "用户关注公众号自动生成专属裂变名片海报",
                desc: "",
                ishave: false,
              },
              { title: "支持设置多类型奖励", desc: "", ishave: false },
              {
                title: "支持按完成任务或者邀请排行自动兑奖",
                desc: "",
                ishave: false,
              },
              { title: "支持用户添加好友自动兑奖", desc: "", ishave: false },
              { title: "支持用户添加自动打标签", desc: "", ishave: false },
              { title: "支持用户添加好友自动拉群", desc: "", ishave: false },
              { title: "海报灵活个性化配置", desc: "", ishave: false },
              { title: "可实现多人自动分流", desc: "", ishave: false },
              { title: "提供裂变参考话术", desc: "", ishave: false },
              { title: "提供实时排行榜", desc: "", ishave: false },
              { title: "记录用户分享推荐关系", desc: "", ishave: false },
              { title: "活动结束回复设置", desc: "", ishave: false },
            ],
            推广素材库: [
              { title: "海报模板套用", desc: "限时免费", ishave: false },
              { title: "发圈模板套用", desc: "限时免费", ishave: false },
              { title: "团队素材共创共享", desc: "限时免费", ishave: false },
            ],
            数据统计分析: [
              { title: "总拉新人数统计", desc: "", ishave: true },
              { title: "每日拉新人数统计", desc: "", ishave: true },
              { title: "引流数据统计", desc: "", ishave: true },
              { title: "裂变传播数据分析", desc: "", ishave: false },
            ],
            母版设置同步: [
              { title: "引流活码设置同步", desc: "", ishave: false },
              { title: "裂变活动设置同步", desc: "", ishave: false },
              { title: "获客表单设置同步", desc: "", ishave: false },
            ],
            增值服务: [
              { title: "软件安装配置", desc: "", ishave: true },
              { title: "专属客服", desc: "", ishave: true },
              { title: "官方教程", desc: "", ishave: true },
              { title: "3天企业微信获客训练营", desc: "赠送", ishave: false },
              {
                title: "23节企业微信运营增长体系课",
                desc: "赠送",
                ishave: false,
              },
              { title: "线下课程培训", desc: "按需收费", ishave: false },
              { title: "运营方案策划", desc: "按需收费", ishave: false },
              { title: "社群运营指导", desc: "", ishave: false },
              { title: "功能定制", desc: "按需收费", ishave: false },
            ],
          },
        },
        {
          productno: ptypes.专业版,
          descs: {
            绑定数量: [
              { title: "支持绑定的企业微信数量", desc: "1个", ishave: true },
            ],
            活码限制: [
              { title: "创建二维码数量", desc: "不限", ishave: true },
              {
                title: "总引流人数限制",
                desc: "不限",
                ishave: true,
              },
            ],
            活码类型: [
              { title: "永久群活码", desc: "", ishave: true },
              { title: "渠道名片码", desc: "", ishave: true },
              { title: "自动拉群", desc: "", ishave: true },
              { title: "多人活码", desc: "", ishave: true },
            ],
            欢迎语回复: [
              { title: "加好友自动发消息", desc: "", ishave: true },
              { title: "自动发送专属欢迎语/图片/外链", desc: "", ishave: true },
              { title: "自动生成专属欢迎海报", desc: "", ishave: true },
              { title: "插入用户昵称，员工姓名等个性化标签", desc: "", ishave: true },
              { title: "自动打标签", desc: "", ishave: true },
            ],
            获客表单: [
              { title: "设计、发布表单", desc: "", ishave: true },
              { title: "表单模板中心", desc: "", ishave: true },
              { title: "表单数据查看与导出", desc: "", ishave: true },
              { title: "重复填写限制", desc: "", ishave: true },
              { title: "跳题逻辑/关联逻辑", desc: "", ishave: true },
              { title: "用户报名数据微信提醒查看", desc: "", ishave: true },
              { title: "不同选项提交之后展示不同内容", desc: "", ishave: true },
              { title: "不同选线提交之后跳转不同链接", desc: "", ishave: true },
              {
                title: "自动给填写表单的企业微信好友打标签",
                desc: "",
                ishave: true,
              },
              { title: "生成专属分享二维码", desc: "", ishave: true },
              { title: "记录用户分享的推荐关系", desc: "", ishave: true },
            ],
            好友裂变: [
              {
                title: "用户添加好友自动生成专属裂变名片海报",
                desc: "",
                ishave: true,
              },
              { title: "支持设置多类型奖励", desc: "", ishave: true },
              {
                title: "支持按完成任务或者邀请排行自动兑奖",
                desc: "",
                ishave: true,
              },
              { title: "支持用户添加好友自动兑奖", desc: "", ishave: true },
              { title: "支持用户添加自动打标签", desc: "", ishave: true },
              { title: "海报灵活个性化配置", desc: "", ishave: true },
              { title: "可实现多人自动分流", desc: "", ishave: true },
              { title: "提供裂变参考话术", desc: "", ishave: true },
              { title: "提供实时排行榜", desc: "", ishave: true },
              { title: "客户任务完成兑奖提醒", desc: "", ishave: true },
              { title: "记录用户分享推荐关系", desc: "", ishave: true },
              { title: "活动结束回复设置", desc: "", ishave: true },
            ],
            冲榜裂变: [
              {
                title: "用户关注公众号自动生成专属裂变名片海报",
                desc: "",
                ishave: true,
              },
              { title: "支持设置多类型奖励", desc: "", ishave: true },
              {
                title: "支持按完成任务或者邀请排行自动兑奖",
                desc: "",
                ishave: true,
              },
              { title: "支持用户添加好友自动兑奖", desc: "", ishave: true },
              { title: "支持用户添加自动打标签", desc: "", ishave: true },
              { title: "支持用户添加好友自动拉群", desc: "", ishave: true },
              { title: "海报灵活个性化配置", desc: "", ishave: true },
              { title: "可实现多人自动分流", desc: "", ishave: true },
              { title: "提供裂变参考话术", desc: "", ishave: true },
              { title: "提供实时排行榜", desc: "", ishave: true },
              { title: "记录用户分享推荐关系", desc: "", ishave: true },
              { title: "活动结束回复设置", desc: "", ishave: true },
            ],
            推广素材库: [
              { title: "海报模板套用", desc: "限时免费", ishave: false },
              { title: "发圈模板套用", desc: "限时免费", ishave: false },
              { title: "团队素材共创共享", desc: "限时免费", ishave: false },
            ],
            数据统计分析: [
              { title: "总拉新人数统计", desc: "", ishave: true },
              { title: "每日拉新人数统计", desc: "", ishave: true },
              { title: "引流数据统计", desc: "", ishave: true },
              { title: "裂变传播数据分析", desc: "", ishave: true },
            ],
            母版设置同步: [
              { title: "引流活码设置同步", desc: "", ishave: false },
              { title: "裂变活动设置同步", desc: "", ishave: false },
              { title: "获客表单设置同步", desc: "", ishave: false },
            ],
            增值服务: [
              { title: "软件安装配置", desc: "", ishave: true },
              { title: "专属客服", desc: "", ishave: true },
              { title: "官方教程", desc: "", ishave: true },
              { title: "3天企业微信获客训练营", desc: "赠送", ishave: false },
              {
                title: "23节企业微信运营增长体系课",
                desc: "赠送",
                ishave: false,
              },
              { title: "线下课程培训", desc: "按需收费", ishave: false },
              { title: "运营方案策划", desc: "按需收费", ishave: false },
              { title: "社群运营指导", desc: "", ishave: true },
              { title: "功能定制", desc: "按需收费", ishave: false },
            ],
          },
        },
      ],
    };
  },
  watch: {},
  methods: {
    ...mapActions(["getFirmInfoAsync"]),
    //发起支付
    gopay(productno) {
      if (!this.agreeBuyProtocol) {
        Toast("请勾选服务协议");
      } else {
        var t = this;
        var useragent = window.navigator.userAgent.toLowerCase();
        t.iorder.productno = productno || t.productno_sel;
        //判断当前支付环境
        if (t.ismobile_()) {
          //微信环境 调起jssdk支付
          if (
            useragent.match(/micromessenger/i) == "micromessenger" &&
            useragent.match(/wxwork/i) != "wxwork"
          )
            t.buildorderjs();
          //其他环境调用h5支付
          else t.buildorderh5();
        }
        //pc环境用扫码支付
        else t.buildordernat();
      }
    },

    //获得微信扫码的支付订单
    buildordernat() {
      var t = this;
      var loading = Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      t.nativeloading = true;
      t.$http
        .post("/Order/BuildOrderWXNATIVE", t.iorder, 2)
        .then((res) => {
          loading.clear();
          t.nativeloading = false;
          if (res.resultState == 1) {
            t.natorderamount = res.Data.orderamount.toFixed(2);
            t.natlink = res.Data.qrcodeurl;
            t.natlinkqrcode = t.$qrcode.getQrBase64(t.natlink);
            t.nativeshow = true;
            t.payorderno = res.Data.orderno;
            //监听微信扫码支付结果
            t.natresult();
          } else Toast(res.errorMsg);
        })
        .catch((error) => {
          loading.clear();
          Toast("网络异常，请稍后重试");
        });
    },
    natresult() {
      var t = this;
      t.$http
        .get("/Order/QueryOrderNat", { orderno: t.payorderno }, 2)
        .then((res) => {
          t.nativeloading = false;
          if (res.resultState == 1 && res.Data == 1) {
            t.natstatus = 1;
            setTimeout(() => {
              t.$router.replace({
                path: "/product/payresult?orderno" + t.payorderno,
                query: {},
              });
            }, 1000);
          } else
            timer = setTimeout(() => {
              t.natresult();
            }, 1500);
        })
        .catch((error) => {
          timer = setTimeout(() => {
            t.natresult();
          }, 1500);
        });
    },
    nativeclose() {
      this.natstatus = 0;
      if (timer) clearTimeout(timer);
    },
    buildorderh5() {
      var t = this;
      var loading = Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      t.h5loading = true;
      t.$http
        .post("/Order/BuildOrderH5", t.iorder, 2)
        .then((res) => {
          loading.clear();
          if (res.resultState == 1) {
            t.payorderno = res.Data;
            var callback = `${window.location.origin}${
              process.env.BASE_URL
            }/#/product/index?type=back`;
            var payurl = `${config.protocol}://${
              config.apiprefix
            }/wx/gopayh5?orderno=${t.payorderno}&callback=${encodeURIComponent(
              callback
            )}`;
            console.log("payurl", payurl);
            window.top.location.href = payurl;
          } else {
            Toast(res.errorMsg);
            t.h5loading = false;
          }
        })
        .catch((error) => {
          loading.clear();
          Toast("网络异常，请稍后重试");
        });
    },
    buildorderjs() {
      var t = this;
      var loading = Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      t.jssdkloading = true;
      t.$http
        .post("/Order/BuildOrderJSSDK", t.iorder, 2)
        .then((res) => {
          loading.clear();
          if (res.resultState == 1) {
            t.h5loading = false;
            t.payorderno = res.Data.orderno;
            t.jssdkparams = JSON.parse(res.Data.jssdkparams);
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                console.log("document.addEventListene");
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  t.onBridgeReady,
                  false
                );
              } else if (document.attachEvent) {
                console.log("document.attachEvent");
                document.attachEvent("WeixinJSBridgeReady", t.onBridgeReady);
                document.attachEvent("onWeixinJSBridgeReady", t.onBridgeReady);
              }
            } else {
              console.log("isloading");
              t.onBridgeReady();
            }
          } else {
            loading.clear();
            t.h5loading = false;
            Toast(res.errorMsg);
          }
        })
        .catch((error) => {
          loading.clear();
          Toast("网络异常，请稍后重试");
        });
    },
    onBridgeReady() {
      var t = this;
      console.log("onBridgeReady", t.jssdkparams);
      t.jssdkloading = false;
      WeixinJSBridge.invoke("getBrandWCPayRequest", t.jssdkparams, function(
        res
      ) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          t.$router.replace({
            path: "/product/payresult?orderno" + t.payorderno,
            query: {},
          });
        }
      });
    },
    //查询订单支付状态
    QueryOrder(type) {
      var t = this;
      t.queryordering = true;
      t.$http
        .get("/Order/QueryOrder", { orderno: t.payorderno }, 2)
        .then((res) => {
          if (res.resultState == 1) {
            t.queryordering = false;
            //支付成功,跳转支付成功页
            if (res.Data == 1) {
              t.$router.replace({
                path: "/product/payresult?orderno" + t.payorderno,
                query: {},
              });
            } else {
              if (type == 1)
                Toast("查询到订单尚未支付，可能存在延迟，请稍后重试");
              t.payresultshow = true;
            }
          } else {
            Toast(res.errorMsg);
          }
        })
        .catch((error) => {
          Toast("网络异常，请刷新后重试");
          console.log("QueryOrder Error", error);
        });
    },

    reh5pay() {
      var t = this;
      var callback = `${window.location.origin}${
        process.env.BASE_URL
      }/#/product/index?type=back`;
      var payurl = `${config.protocol}://${
        config.apiprefix
      }/wx/gopayh5?orderno=${t.payorderno}&callback=${encodeURIComponent(
        callback
      )}`;
      console.log("payurl", payurl);
      window.top.location.href = payurl;
    },
    goAnchor(selector) {
      document.body.scrollTop = document.getElementById(selector).offsetTop;
      document.documentElement.scrollTop = document.getElementById(
        selector
      ).offsetTop;
    },
  },
  components: {},
  computed: {
    ...mapState(["firminfo"]),
    ...mapGetters(["firmVersionDetail", "getPackageInfo"]),
  },
  async created() {
    if (this.$route.query.type && this.$route.query.type == "back") {
      if (this.$route.query.errcode && this.$route.query.errcode == 1) {
        var errmsg = decodeURIComponent(
          this.$route.query.errmsg || "支付失败，请稍后重试"
        );
        Toast(errmsg);
      } else {
        this.payorderno = this.$route.query.orderno;
        this.QueryOrder();
      }
    }

    await this.getFirmInfoAsync();
    console.log(
      "this.firmVersionDetail.version",
      this.firmVersionDetail.version
    );
    if (this.firmVersionDetail.version == "专业版")
      this.productno_sel = ptypes.专业版;
  },
  mounted() {
    if (this.$route.query.scrollid) this.goAnchor(this.$route.query.scrollid);
  },
  updated() {},
  destroyed() {
    if (timer) clearTimeout(timer);
  },
};
</script>
<style>
.van-checkbox__icon {
  font-size: inherit;
}
</style>
<style scoped lang="scss">
@import "../../../static/scss/var";
.product-index {
  background-color: #fff;
  position: relative;
  .right-btn {
    position: fixed;
    right: 0;
    bottom: vw(200);
    z-index: 2;
    .btn-server {
      width: vw(100);
      height: vw(100);
      @include flex;
      @include align_items_center;
      @include justify_content_flex_center;
      background: url(../../../static/images/product/icon-server@2x.png) center
        no-repeat;
      background-size: 100% 100%;
      color: #fff;
      font-size: vw(28);
      font-weight: 500;
      margin-right: vw(25);
      box-shadow: vw(3) vw(3) vw(10) rgba(180, 180, 180, 0.6);
      border-radius: 50%;
    }
  }
  .product-head {
    position: absolute;
    width: 100%;
    height: vw(150);
    background-color: #4356d2;
    z-index: 0;
  }
  .product-content {
    position: relative;
    z-index: 1;
    padding: vw(24);
    padding-top: vw(50);
    padding-bottom: 0;
    .firminfo {
      @include flex;
      @include align_items_center;
      height: vw(200);
      box-sizing: border-box;
      padding: vw(46) vw(30);
      box-shadow: 0px 4px 6px 0px rgba(236, 236, 236, 1);
      border-radius: vw(20);
      background-color: #fff;
      margin-bottom: vw(10);

      @include flex;
      .firmicon {
        width: vw(108);
        height: vw(108);
        border-radius: 50%;
      }
      .firmdesc {
        margin-left: vw(20);
        @include flex_1;
        .xl-title {
          line-height: vw(50);
          font-size: vw(36);
          height: vw(50);
          font-family: AlibabaPuHuiTiR;
        }
        .vipinfo {
          font-size: vw(26);
          color: #666666;
          line-height: vw(36);
          height: vw(36);
        }
      }
    }

    .vipmenu {
      margin: 0 vw(-24);
      background-color: #fff;
      padding: vw(20) vw(80);
      @include flex;
      .vipmenu-item {
        cursor: pointer;
        @include flex;
        @include justify_content_flex_center;
        @include flex_1;
        @include align_items_center;
        @include flex_direction_column;
        line-height: vw(44);
        color: #666666;
        font-size: vw(32);
        .line {
          width: vw(120);
          height: vw(6);
          border-radius: vw(3);
          display: none;
          background-color: #fe972f;
          margin-top: vw(5);
        }
      }
      .active {
        color: #fe972f;
        font-weight: 500;
        .line {
          display: block;
        }
      }
    }

    .version {
      @include flex;
      .version-item {
        height: vw(240);
        margin-right: vw(10);
        @include flex;
        @include justify_content_flex_center;
        @include align_items_center;
        @include flex_direction_column;
        @include flex_1;
        border: vw(3) solid #eaeaea;
        border-radius: vw(12);
        box-sizing: border-box;
        cursor: pointer;
        .xl-title {
          font-size: vw(32);
          line-height: vw(44);
          margin-bottom: vw(8);
          color: #666;
        }
        .xm-title {
          font-size: vw(24);
          line-height: vw(34);
          color: #999;
          .hig {
            color: #fe2e2e;
          }
        }
      }
      .version-item:last-child {
        margin-right: 0;
      }
      .active {
        background-color: #fff7f1;
        border-color: #ffcd97;
        .xl-title {
          color: #9d5113;
        }
      }
    }
    .xieyi {
      @include flex;
      @include align_items_center;
      @include justify_content_flex_center;
      font-size: vw(24);
      line-height: vw(34);
      margin-top: vw(40);
      .van-checkbox {
        margin-right: vw(3);
        font-size: vw(24);
      }

      a {
        color: #4356d2;
      }
    }
    .btn-xl-buy {
      width: 100%;
      height: vw(98);
      color: #9d5113;
      font-size: vw(40);
      border: 0;
      font-weight: 500;
      background: url(../../../static/images/product/btn-buy1.png) center
        no-repeat;
      background-size: 100% 100%;
      margin: vw(16) 0 vw(50) 0;
      cursor: pointer;
    }
    .btn-enabled {
      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
      -o-filter: grayscale(100%);

      filter: grayscale(100%);

      filter: gray;
    }
    .version-title {
      @include flex;
      @include align_items_center;
      @include justify_content_flex_center;
      margin-bottom: vw(30);
      .line {
        width: vw(200);
        border-bottom: 1px solid #e7e7e7;
        display: inline-block;
      }
      .round {
        display: inline-block;
        width: vw(6);
        height: vw(6);
        background-color: #e7e7e7;
        margin: 0 vw(10);
      }
      .text {
        font-size: vw(28);
        color: #666;
      }
    }
    .version-desc {
      background-color: #f4f4f4;
      margin: 0 vw(-24);
      ul,
      li {
        list-style: none;
        padding: 0;
        margin: 0;
      }
      ul {
        li {
          @include flex;
          @include align_items_center;
          padding: 0 vw(44);
          background-color: #fff;
          border-bottom: 1px solid rgba(235, 235, 235, 1);
          height: vw(80);
          .title {
            color: #333333;
            font-size: vw(28);
            @include flex_1;
          }
          .desc,
          .icon {
            margin-left: vw(20);
          }
          .desc {
            color: #999999;
            font-size: vw(28);
          }
          .icon {
            width: vw(32);
            height: vw(32);
          }
        }
        li:last-child {
          border-bottom: 0;
        }
      }
    }

    .package-list {
      padding-bottom: vw(30);
      .package-item {
        margin-top: vw(20);
        padding: vw(25);
        background-color: #fff7f1;
        border: vw(3) solid #ffd09d;
        border-radius: vw(15);
        .package-head {
          height: vw(80);
          @include flex;
          @include align_items_center;
          .package-title {
            @include flex_1;
            color: #9d5113;
            font-size: vw(34);
            font-weight: 500;
          }
          .package-exptime {
            margin-left: vw(20);
            font-size: vw(24);
            color: #666666;
          }
        }

        .package-desc {
          ul,
          li {
            list-style: none;
            padding: 0;
            margin: 0;
          }
          color: #666666;
          font-size: vw(26);
          line-height: vw(48);
        }

        .package-bottom {
          @include flex;
          @include align_items_center;
          .package-price {
            @include flex_1;
            color: #fe514b;
            font-size: vw(32);
          }
          .btn-sm-buy {
            color: #9d5113;
            font-size: vw(32);
            cursor: pointer;
            height: vw(82);
            width: vw(260);
            margin-left: vw(30);
            font-weight: 500;
            background: url(../../../static/images/product/btn-buy2.png) center
              no-repeat;
            background-size: 100% 100%;
            border: 0;
          }
        }
      }
    }
  }

  .product-content-bg {
    background-color: #f4f4f4;
  }
}
.native-box {
  width: vw(500);
  padding: vw(50) 0;
  text-align: center;
  position: relative;
  @include flex;
  @include align_items_center;
  @include flex_direction_column;

  .native-success {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);

    @include flex;
    @include align_items_center;
    @include justify_content_flex_center;
    z-index: 1;
  }
  .native-success-icon {
    width: vw(120);
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: vw(-60);
    margin-top: vw(-60);
    z-index: 2;
  }
  .icon-wxpay {
    width: vw(90);
    height: vw(90);
    background-color: #1fad15;
    border-radius: 50%;
    @include flex;
    @include align_items_center;
    @include justify_content_flex_center;
    img {
      width: vw(60);
      height: vw(60);
    }
  }

  .title {
    line-height: vw(60);
    margin: vw(30) 0;
    font-size: 30px;
    .amount {
      color: #ff3300;
      margin-right: vw(3);
    }
  }

  .qrcode {
    width: vw(300);
  }
  .desc {
    @include flex;
    @include align_items_center;
    @include justify_content_flex_center;
    color: $vm_fontcolor_warning;
    .van-icon {
      margin-right: vw(3);
      font-size: 18px;
    }
  }
  .success {
    color: #04be02;
  }
}

.message-box {
  width: vw(500);
  padding: 0 vw(30) vw(20) vw(30);
  .info {
    padding: vw(80) 0 vw(60) 0;
    font-size: 18px;
  }
  .van-button {
    margin-bottom: vw(20);
  }
}

// .title {
//   color: #c1c1c1;
//   font-size: vw(28);
//   font-weight: 400;
// }
// 标题颜色 #121212  内容颜色 #666666
// .desc {
//   color: #999999;
//   font-size: vw(28);
// }
.showCard {
  display: flex;
  padding-left: vw(30);
  justify-content: space-between;
  height: vw(60);
  line-height: vw(60);
  overflow: hidden;
  // border-bottom: 1px solid #f6f7f8 ;
  .icon {
    width: vw(32);
    height: vw(32);
    margin-top: vw(16);
    margin-right: vw(16);
  }
  .desc {
    color: #999999;
    font-size: vw(28);
  }
  .title {
    color: #666666;
    font-size: vw(28);
    font-weight: 400;
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only <style scoped  lang="scss" src="../../static/scss/shareindex.scss"></style>-->
